import _sfc_main from './src/color-picker-panel.vue2.mjs';
export { ROOT_COMMON_COLOR_INJECTION_KEY, colorPickerPanelContextKey, colorPickerPanelEmits, colorPickerPanelProps } from './src/color-picker-panel.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElColorPickerPanel = withInstall(_sfc_main);

export { ElColorPickerPanel, ElColorPickerPanel as default };
//# sourceMappingURL=index.mjs.map
